import { SupportedCountry } from 'generated/graphql';

/**
 * How each market refers to itself in editorial copy. The design writes "New
 * Zealand's most exciting architectural projects…" and the same line runs in
 * Australia and the US, so the possessive is the only part that moves.
 */
const MARKET_POSSESSIVE: Record<SupportedCountry, string> = {
    [SupportedCountry.Nz]: "New Zealand's",
    [SupportedCountry.Au]: "Australia's",
    [SupportedCountry.Us]: "America's",
};

/** Falls back to NZ, the market the design was drawn for. */
export const marketPossessive = (country?: string): string =>
    MARKET_POSSESSIVE[country as SupportedCountry] ??
    MARKET_POSSESSIVE[SupportedCountry.Nz];

/**
 * The standing line under the masthead. Fixed editorial copy rather than the
 * page's CMS description, which is written for search engines and reads as
 * boilerplate in a 33px display setting.
 */
export const introStripCopy = (country?: string): string =>
    `${marketPossessive(country)} most exciting architectural projects, products and professionals featured weekly in an interactive experience`;

/**
 * The subscribe tile's body (Figma 51:911). Wraps to four lines in the 805
 * column at 33px in every market — the possessive is the longest variable and
 * it only moves the first line.
 */
export const subscribeTileBody = (country?: string): string =>
    `Subscribe to our Digital Publications: ${marketPossessive(country)} most exciting architectural projects, products and professionals featured weekly in an interactive experience delivered to your inbox.`;

/**
 * The promo band's body (Figma 60:2173), sized to the design's three lines in
 * the 621 column at 22px.
 */
export const promoBandBody = (country?: string): string =>
    `${marketPossessive(country)} most exciting architectural projects, products and professionals, featured weekly in an interactive experience delivered straight to your inbox.`;
